/**
 * 필수값 확인
 * @param {any} value
 * @returns {string|null}
 */
export const isRequired = (value) => {
  if (typeof value === "string" && value.trim() === "") {
    return "값을 입력해주세요.";
  }

  return value === undefined || value === null || value === ""
    ? "값을 입력해주세요."
    : null;
};

/**
 * 숫자인지 확인
 * @param {any} value
 * @returns {string|null}
 */
export const isNumber = (value) => {
  if (typeof value === "string" && value.trim() === "") {
    return "값을 입력해주세요.";
  }
  return isNaN(Number(value)) ? "숫자를 입력해주세요." : null;
};

/**
 * 숫자가 지정된 범위 내에 있는지 확인
 * @param {number} min
 * @param {number} max
 * @returns {(value: any) => string|null}
 */
export const isInRange = (value, min, max) => {
  const num = Number(value);
  if (value === "" || isNaN(num)) return "숫자를 입력해주세요.";
  if (num < min || num > max)
    return `${min} 이상 ${max} 이하의 숫자를 입력해주세요.`;
  return null;
};

/**
 * 이메일 형식인지 확인
 * @param {string} value
 * @returns {string|null}
 */
export const isEmail = (value) => {
  if (typeof value !== "string") return "올바른 이메일을 입력해주세요.";

  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  return emailRegex.test(value) ? null : "올바른 이메일 형식이 아닙니다.";
};

/**
 * 휴대전화 번호 형식인지 확인
 * @param {string} value
 * @returns {string|null}
 */
export const isPhoneNumber = (value, onlyNumber = true) => {
  if (typeof value !== "string") return "휴대전화는 문자열이어야 합니다.";
  let phoneRegex = "";
  let ex = "";

  if (onlyNumber) {
    phoneRegex = /^\d{11}$/;
    ex = "01012345678";
  } else {
    phoneRegex = /^\d{3}-\d{4}-\d{4}$/;
    ex = "010-1234-5678";
  }

  return phoneRegex.test(value)
    ? null
    : `휴대전화 형식이 올바르지 않습니다. (예: ${ex})`;
};

/**
 * URL 형식인지 확인
 * @param {string} value
 * @returns {string|null}
 */
export const isUrl = (value) => {
  if (typeof value !== "string") return "올바른 URL 형식을 입력해주세요.";

  const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

  return urlRegex.test(value) ? null : "올바른 URL 형식을 입력해주세요.";
};

// 모든 함수를 객체로도 export
export default {
  isRequired,
  isNumber,
  isInRange,
  isEmail,
  isPhoneNumber,
  isUrl,
};
